export default "__VITE_ASSET__TYgghzg4__"